import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';

import App from './App.vue';
import { router, bindHttpAuthHandlersToRouter } from './router';
import { vuetify } from './plugins/vuetify';
import { vueQueryOptions } from './plugins/queryClient';
import { initSentry } from './shared/observability/sentry';
import { logger } from './shared/observability/logger';
import './shared/design-system/styles/global.scss';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(VueQueryPlugin, vueQueryOptions);

// Wire up HTTP 401/403 handlers after Pinia is installed.
bindHttpAuthHandlersToRouter();

initSentry(app, router);

app.config.errorHandler = (err, _vm, info) => {
  logger.error({ event: 'app.error', err, info }, 'unhandled error');
};

logger.info({ event: 'app.boot' }, 'cc-admin starting');

app.mount('#app');
